import { cva, type VariantProps } from "class-variance-authority";
import type { ButtonHTMLAttributes } from "react";

import { cn } from "@/lib/utils";

const buttonVariants = cva(
  "inline-flex items-center justify-center rounded-full-pill border border-transparent px-5 py-3 text-sm font-bold uppercase tracking-[1.4px] transition focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:pointer-events-none disabled:opacity-50",
  {
    variants: {
      variant: {
        primary: "bg-primary text-primary-foreground shadow-halo hover:bg-primary/92",
        secondary: "bg-spotify-surface-light text-foreground hover:bg-spotify-card",
        outline:
          "border-spotify-border bg-transparent text-foreground hover:border-foreground/40 hover:bg-foreground/5",
        ghost: "bg-transparent text-foreground hover:bg-foreground/5",
      },
      size: {
        default: "min-h-12",
        compact: "min-h-10 px-4 py-2",
      },
    },
    defaultVariants: {
      variant: "primary",
      size: "default",
    },
  },
);

export { buttonVariants };

export interface ButtonProps
  extends ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof buttonVariants> {}

export function Button({
  className,
  size,
  variant,
  ...props
}: ButtonProps): JSX.Element {
  return (
    <button
      className={cn(buttonVariants({ className, size, variant }))}
      {...props}
    />
  );
}
